'use strict';

import { Tabs } from './tabs.js';

export class TabsPaDurationsTab extends Tabs {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		this.$items.on('click', this.option_click_handler.bind(this));
		// Set initial selected month on init
		let $initial_item = this.$items.filter('.js-active').first();
		if (!$initial_item.length) {
			$initial_item = this.$items.first();
		}
		if ($initial_item.length) {
			const selected_month = $initial_item.data('month');
			jQuery('.js-tabs_pa_durations_tab')
				.attr('data-selected-month', selected_month);
		}
	}
	
	option_click_handler(event) {
		const $clicked_item = jQuery(event.currentTarget);
		if ($clicked_item.hasClass('active')) {
			event.preventDefault();
		}

		let feature_id = 0;
		
		// Change active tab class
		let current_index = $clicked_item.data('index');
		jQuery('.js-pa_payment_select_duration_tab').removeClass('js-active');
		jQuery('.js-pa_payment_select_duration_tab[data-index="' + current_index + '"]').addClass('js-active');
		let selected_month = $clicked_item.data('month');
		// Update the selected month on the tabs element so dropdown JS can read it
		jQuery('.js-tabs_pa_durations_tab').attr('data-selected-month', selected_month);
		feature_id = $clicked_item.data('featureid');
		// Show/hide month content sections
		yalwa.basics.hide(jQuery('.js-month_wrapper'));
		yalwa.basics.show(jQuery(`.js-month_wrapper[data-month="${selected_month}"]`));
		jQuery('.js-month_wrapper').removeClass('js-active');
		jQuery(`.js-month_wrapper[data-month="${selected_month}"]`).addClass('js-active');
		
		// Scroll the horizontal tab bar to show the clicked item
		const zero_point = this.$elements.position().left;
		const current_item_left = $clicked_item.position().left;
		const scroll_to = current_item_left - zero_point;
		this.$elements.scrollLeft(scroll_to);
		
		this.show_data_in_compareGrid(selected_month);
		
		//Sync scroll of all the sliders
		let $slider_el = jQuery('.js-snapslider');
		let scroll_left_value = $slider_el.data('sl_value');
		$slider_el.scrollLeft(scroll_left_value);
	}
	
	show_data_in_compareGrid(selected_month) {
		//Data
		let labels_data = yalwa.v.components.tabs_pa_durations_tab.json_data.labels_data;
		let prices = yalwa.v.components.tabs_pa_durations_tab.json_data.prices;
		let feature_ids = yalwa.v.components.tabs_pa_durations_tab.json_data.feature_ids;
		let month_wise_plans = yalwa.v.components.tabs_pa_durations_tab.json_data.month_wise_plans;

		// Show/hide columns based on active plans for this month
		const plan_css_map = { 4: 'essential', 5: 'advanced', 6: 'vip' };
		const active_plans = month_wise_plans[selected_month] || [];
		const num_plans = active_plans.length;

		// Update CSS grid column count to match active plan count
		const $compare_grid = jQuery('.comparegrid');
		$compare_grid.each(function () {
			// Swap block modifier: comparegrid--4 → comparegrid--3 etc.
			this.className = this.className.replace(/\bcomparegrid--\d+\b/g, '');
			jQuery(this).addClass('comparegrid--' + num_plans);
		});
		// Swap compare_rows element modifier: --count_4 → --count_3 etc.
		const $rows = $compare_grid.find('.comparegrid__compare_rows');
		$rows.each(function () {
			this.className = this.className.replace(/\bcomparegrid__compare_rows--count_\d+\b/g, '');
			jQuery(this).addClass('comparegrid__compare_rows--count_' + num_plans);
		});

		// Hide/show individual grid columns (desktop head + body only; mobile head stays visible)
		Object.entries(plan_css_map).forEach(([plan_val, css_name]) => {
			const is_active = active_plans.includes(parseInt(plan_val));
			const $columns = jQuery(
				'.js-show_compare_grid_head_desktop[data-type="' + plan_val + '"], ' +
				'.js-plan_detail[data-type="' + plan_val + '"], ' +
				'.comparegrid__middle_col--' + css_name
			);
			if (is_active) {
				$columns.show();
			} else {
				$columns.hide();
			}
		});

		// Also hide inactive plans from the mobile dropdown options,
		// and auto-switch to first active plan if the current selection is now inactive
		const dropdown_ids = [
			'dropdown_pacomparedropdown_default',
			'dropdown_pacomparedropdown_default_2',
			'dropdown_pacomparedropdown_overlay',
			'dropdown_pacomparedropdown_overlay_2'
		];
		dropdown_ids.forEach(did => {
			jQuery(`.js-${did}_option`).each((_, el) => {
				const $el = jQuery(el);
				if ($el.data('id') && !active_plans.includes($el.data('id'))) {
					$el.hide();
				} else {
					$el.show();
				}
			});
			// If currently selected option is now inactive, switch to first active
			const $selected = jQuery(`.js-${did}_selected`);
			const $current = $selected.find(`.js-${did}_option`);
			const current_id = $current.data('id');
			if (current_id && !active_plans.includes(current_id)) {
				const $first_active = jQuery(`.js-${did}_option`).filter(':visible').first();
				if ($first_active.length) {
					$first_active.trigger('click');
				}
			}
		});

		//Update Labels
		Object.entries(labels_data[selected_month]).forEach(([pa, labels]) => {
			Object.entries(labels).forEach(([key, text]) => {
				let el = `js-grid_data_key_${key}_${pa}`;
				const val = Array.isArray(text) ? text[0] : text;
				jQuery('.' + el).html(val ? '<span>' + val + '</span>' : '');
			});
		});
		
		//Update Prices
		Object.entries(prices[selected_month]).forEach(([pa, data]) => {
			let el = `js-compare_price_box_label_${pa}`;
			jQuery('.' + el).html(data.html_per_month);
		});
		
		//Update FeatureIDs
		Object.entries(feature_ids[selected_month]).forEach(([pa, data]) => {
			let el = `js-grid_data_button_${pa}`;
			const $buttons = jQuery('.' + el);
			$buttons.attr('data-featureid', data.feature_id);
			if (data.freebies) {
				const freebies = JSON.stringify(data.freebies);
				$buttons.attr('data-freebies', freebies);
			} else {
				$buttons.removeAttr('data-freebies');
			}
			jQuery('.js-get_started_data[data-type="'+pa+'"]').attr('data-featureid', data.feature_id)
		});
	}
}
